<template>
    <div class="p-5 mt-5">
        <el-row>
            <el-col>
                <el-card class="shadow-sm custom-card">
                    <template #header>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center back-btn" @click="onBack">
                                <i class="mdi mdi-arrow-left mr-2" />
                                <p>Back</p>
                            </div>
                            <div class="d-flex gap-2">
                                <el-button v-for="(device, idx_device) in devices" :key="idx_device"
                                    :type="selected === device ? 'primary' : 'default'"
                                    @click="onSelectedDevice(device)">
                                    {{ device }}
                                </el-button>
                            </div>
                        </div>
                    </template>
                    <div class="card-body-custom p-5 w-100" style="background-color: #f9fafb;">
                        <div v-if="preview_template.body.data.length" :class="['preview-wrapper', selected.toLowerCase()]">
                            <iframe
                              class="preview-content p-3"
                              :srcdoc="previewContent"
                            />
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import {
  escapeRegExp,
} from 'lodash';

export default {
  name: 'Broadcast Preview Templates Email',
  data() {
    return {
      preview_template: {},
      form: {},
      step: 0,
      devices: ['Mobile', 'Desktop'],
      selected: 'Desktop',
      temp: {},
      templateId: null,
      selectedElement: {},
    };
  },
  mounted() {
    const { state } = window.history;
    if (state && state.template && state.form && state.step && state.temp && state.selectedElement) {
      this.preview_template = state.template;
      this.form = state.form;
      this.step = state.step;
      this.temp = state.temp;
      this.templateId = state.templateId;
      this.selectedElement = state.selectedElement;
    }
  },
  computed: {
    previewContent() {
      let string = this.preview_template.body.content;
      this.preview_template.body.examples.forEach((v) => {
        if (v.text) {
          const replaceRegex = new RegExp(escapeRegExp(v.replacement), 'ig');
          string = string.replace(replaceRegex, v.text);
        }
      });
      const htmlFormat = [
        { symbol: '*', tag: 'b' },
        { symbol: '_', tag: 'em' },
        { symbol: '~', tag: 'del' },
        { symbol: '```', tag: 'tt' },
        { symbol: '`', tag: 'mark' },
      ];

      htmlFormat.forEach(({ symbol, tag }) => {
        if (!string) return;
        const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`, 'gm');
        const match = string.match(regex);
        if (!match) return;
        match.forEach((m) => {
          if (m.includes('<a') || m.includes('href=')) return;
          let formatted = m;
          /* eslint-disable no-plusplus */
          for (let i = 0; i < 2; i++) {
            formatted = formatted.replace(symbol, `<${i > 0 ? '/' : ''}${tag}>`);
          }
          string = string.replace(m, formatted);
        });
      });
      const previewExtraCSS = `
        body {
          padding: 20px !important;
          margin: 0 !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          width: 100% !important;
          box-sizing: border-box !important;
          overflow-x: hidden !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
        }

        .template-img {
          max-width: 100% !important;
          margin: 0 auto !important;
          padding: 10px !important;
          background-color: #ccd0d5 !important;
          background-position: center !important;
          background-repeat: no-repeat !important;
          background-size: contain !important;
          border-radius: 4px !important;
        }

        p, span, b, div, h1, h2, h3 {
          width: 100% !important;
          max-width: 100% !important;
          word-break: break-word !important;
          box-sizing: border-box !important;
        }

        @media screen and (max-width: 600px) {
          body {
            padding: 15px !important;
            line-height: 1.2 !important;
          }

          .template-img {
            padding: 30px !important;
            background-color: read;
            background-size: 60px 60px !important;
          }
       
          table, div, img {
            max-width: 100% !important;
            box-sizing: border-box !important;
          }
        }
      `;

      if (string.match(/<style[^>]*>/i)) {
        string = string.replace(
          /<\/style>/i,
          `${previewExtraCSS}</style>`,
        );
      } else if (string.match(/<\/head>/i)) {
        string = string.replace(
          /<\/head>/i,
          `<style>${previewExtraCSS}</style></head>`,
        );
      }

      return string;
    },
  },
  methods: {
    onSelectedDevice(select) {
      this.selected = select;
    },
    onBack() {
      const path = this.templateId ? `/broadcast-templates/email/${this.templateId}` : '/broadcast-templates/create';
      window.history.pushState(
        {
          template: this.preview_template,
          step: this.step,
          form: this.form,
          temp: this.temp,
          templateId: this.templateId,
          selectedElement: this.selectedElement,
        },
        '',
        path,
      );
      this.$router.replace(path);
    },
  },
};
</script>

<style scoped>
.back-btn {
  cursor: pointer;
  color: #118c7f;
}
.back-btn p {
  margin: 0;
}

/* Container wrapper */
.preview-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  transition: all 0.3s ease;
  padding: 20px;
}

/* Desktop */
.preview-wrapper.desktop .preview-content {
  width: 100%;
  height: 600px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* Mobile */
.preview-wrapper.mobile .preview-content {
  width: 600px;
  height: 500px;
  border: 1px solid #ddd;
  border-radius: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
}

</style>
